<div [hidden]="isEdit">
  <button
    mat-icon-button
    data-testid="shared-scandisplay-button"
    (click)="setEdit()"
    [disabled]="disabled || !(currentRoles | hasAnyRoles : ['READER', 'WRITER'] : currentExperiment : 'IsReadyToTest')">
    <mat-icon>sensors</mat-icon>
  </button>
</div>
<div [hidden]="!isEdit">
  <mat-form-field appearance="fill">
    <input
      #scanInput
      (focus)="onFocus($event)"
      (focusout)="saveValue()"
      placeholder="{{ colName }}"
      matInput
      data-testid="shared-scandisplay-input"
      [(ngModel)]="currentValue"
      [disabled]="disabled || !(currentRoles | hasAnyRoles : ['READER', 'WRITER'] : currentExperiment : 'IsReadyToTest')" />
  </mat-form-field>
  <div class="parsed-scan-value">{{ parsedValue }}</div>
</div>
